module.exports = __webpack_public_path__ + "static/media/business-prec-metals-chart-sc.c53f1fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/business-prec-metals-chart-sc.png
// module id = 504
// module chunks = 0